import type { LocaleConsent } from "../types/locale-consent";

const OSANO_DEV_CONFIG_ID = "8c281d89-3761-454d-9778-6772b24fd16a";

function resolveOsanoConfigId(
  consent: LocaleConsent,
  useDevConfig: boolean,
): string {
  if (useDevConfig) {
    return OSANO_DEV_CONFIG_ID;
  }

  return consent.osanoConfigId;
}

export { resolveOsanoConfigId };
